import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Image,
    Link,
    Stack,
    Text,
    useBreakpointValue,
    VisuallyHidden,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const SocialButton = ({ children, label, href }) => {
    return (
        <Link
            external
            bg="blackAlpha.0"
            rounded="full"
            w={8}
            h={8}
            cursor="pointer"
            as="a"
            href={href}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            transition="background 0.3s ease"
            _hover={{
                bg: "blackAlpha.200",
                transform: "scale(1.1)",
            }}
        >
            <VisuallyHidden>{label}</VisuallyHidden>
            {children}
        </Link>
    );
};

export const Footer = ({ visible, props, esGuiaConnect }) => {
    const [_url, setUrl] = useState("");
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const router = useRouter();
    const esGuiaRent = router.pathname.includes("guiarent") || router.pathname.includes("PropRent");
    const esBroker = router.pathname.includes("procesos") || router.pathname.includes("broker");
    const esFichaDesarrollo = router.pathname.includes("/desarrollo/");
    const [_verHero, setVerHero] = useState(visible ? visible : typeof visible === "undefined");

    useEffect(() => {
        setVerHero(esFichaDesarrollo ? false : visible ? visible : typeof visible === "undefined");
    }, [visible, esFichaDesarrollo]);

    useEffect(() => {
        if (esGuiaRent) {
            if (esGuiaRent) {
                setUrl("/terminosycondiciones-guiarent");
            }
            return;
        }
        if (esBroker) {
            setUrl("/terminosycondiciones-guiabroker");
        } else {
            setUrl("/terminosycondiciones");
        }
        if (esGuiaConnect) {
            setUrl("/terminosycondiciones-guiaconnect");
        }
    }, [esGuiaRent, esBroker, esGuiaConnect]);

    const terms = `https://grupoguia.mx/${router.route === "/procesos" ? "terminosycondiciones-soyinmobiliaria" : router.route === "/guiabroker" ? "terminosycondiciones-guiabroker" : "terminosycondiciones"}`;

    return (
        <Box
            bg="blackAlpha.0"
            color="gray.600"
            w="full"
            mx="auto"
            maxW="3x1"
            px={{ base: "6", md: "8" }}
            {...props}
        >
            <Box>
                <Container
                    maxW="8xl"
                    py={10}
                    borderTopWidth={1}
                    borderStyle="solid"
                    borderColor="gray.200"
                    direction={{ base: "column", xl: "row" }}
                    justifyContent={{ base: "center", xl: "space-around" }}
                    alignItems="center"
                    mx="auto"
                    asChild
                >
                    <Flex direction={{ base: "column", xl: "row" }}>
                        <Link href="https://guiarvis.com/" external>
                            <Image
                                src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/icons/guiasvg.svg"
                                alt="Logo Grupo Guía"
                                h={{ base: "30px", md: "40px" }}
                                w="auto"
                            />
                        </Link>
                        <Stack>
                            <Text
                                color="#797979"
                                fontWeight={600}
                                fontSize="sm"
                                pt={4}
                                textAlign="center"
                            >
                                Para atención, quejas y sugerencias:
                            </Text>
                            <Flex
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                mx="auto"
                            >
                                <Stack>
                                    <Flex gap={1}>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/home-page/footer/phone.svg"
                                            alt="phone"
                                            h="15px"
                                            w="15px"
                                        />
                                        <Link
                                            href="tel:3318681590"
                                            color="#797979"
                                            fontSize={{ base: "2xs", sm: "xs" }}
                                            width="80px"
                                        >
                                            33 1868 1590
                                        </Link>
                                    </Flex>
                                </Stack>
                                <Stack gap={1}>
                                    <Flex>
                                        <Image
                                            src="https://media.grupoguia.mx/assets/home-page/footer/email.svg"
                                            alt="phone"
                                            h="15px"
                                            w="15px"
                                            mr={2}
                                        />
                                        <Link
                                            href="mailto:atencionaclientes@grupoguia.mx "
                                            color="#797979"
                                            fontSize={{ base: "2xs", sm: "xs" }}
                                            textDecoration="underline"
                                        >
                                            atencionaclientes@grupoguia.mx 
                                        </Link>
                                    </Flex>
                                </Stack>
                            </Flex>
                        </Stack>
                        <Stack>
                            <Text
                                color="#797979"
                                fontWeight={600}
                                fontSize="sm"
                                pt={4}
                                textAlign="center"
                            >
                                Denuncia anónima
                            </Text>
                            <Stack>
                                <Flex gap={2} alignItems="center">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/footer/email.svg"
                                        alt="email"
                                        h="15px"
                                        w="15px"
                                    />
                                    <Link
                                        href="mailto:tuvozimporta@grupoguia.mx "
                                        color="#797979"
                                        fontSize="sm"
                                        textDecoration="underline"
                                    >
                                        tuvozimporta@grupoguia.mx 
                                    </Link>
                                </Flex>
                            </Stack>
                        </Stack>
                        <Stack direction="row" spacing={6} mt={4}>
                            <SocialButton
                                label="Facebook"
                                href="https://www.facebook.com/GrupoGuia/"
                            >
                                <Image
                                    boxSize={8}
                                    objectFit="cover"
                                    src="https://media.grupoguia.mx/assets/home-page/footer/facebook.svg"
                                    alt="Facebook-icon"
                                    loading="lazy"
                                />
                            </SocialButton>
                            <SocialButton
                                label="Instagram"
                                href="https://www.instagram.com/grupo.guia/"
                            >
                                <Image
                                    boxSize={9}
                                    objectFit="cover"
                                    src="https://media.grupoguia.mx/assets/home-page/footer/instagram.svg"
                                    alt="Instagram-icon"
                                    loading="lazy"
                                />
                            </SocialButton>
                            <SocialButton
                                label="Youtube"
                                href="https://www.youtube.com/channel/UC9fXSlC5VIPjVzExkVN1hEg?view_as=subscriber"
                            >
                                <Image
                                    boxSize={8}
                                    objectFit="cover"
                                    src="https://media.grupoguia.mx/assets/home-page/footer/youtube.svg"
                                    alt="Youtube-icon"
                                    loading="lazy"
                                />
                            </SocialButton>
                            <SocialButton label="Twitter" href="https://twitter.com/grupoguia">
                                <Image
                                    boxSize={8}
                                    objectFit="cover"
                                    src="https://media.grupoguia.mx/assets/home-page/footer/twitter.svg"
                                    alt="Twitter-icon"
                                    loading="lazy"
                                />
                            </SocialButton>
                        </Stack>
                    </Flex>
                </Container>
            </Box>
            <Container
                maxW="8xl"
                mx="auto"
                py={10}
                borderTopWidth={1}
                borderStyle="solid"
                borderColor="gray.200"
                asChild
            >
                <Stack>
                    <Grid templateColumns="repeat(12, 1fr)" gap={6}>
                        <GridItem colSpan={isGreaterThanMd ? 5 : 12} w="100%">
                            <Stack align={{ base: "center", md: "flex-start" }}>
                                <Stack alignItems={{ base: "center", md: "start" }}>
                                    <Text
                                        color=""
                                        fontWeight={600}
                                        fontSize="sm"
                                        textAlign={{ base: "center", md: "start" }}
                                    >
                                        Horario de atención:
                                    </Text>
                                    <Text
                                        color="#797979"
                                        fontWeight={400}
                                        fontSize="sm"
                                        textAlign={{ base: "center", md: "start" }}
                                    >
                                        Lunes a Viernes de 9:00a.m.- 6:00p.m.
                                    </Text>
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/footer/QR+atencion+a+clientes+(1)+1.svg"
                                        alt="qr"
                                        h="100px"
                                        w="100px"
                                        objectFit="contain"
                                        pt={2}
                                    />
                                </Stack>
                                <Stack alignItems={{ base: "center", md: "start" }} mt={4}>
                                    <Text fontWeight={700} fontSize="xl" color="#797979">
                                        Alianzas
                                    </Text>
                                    <Link
                                        href="https://grupoguia.mx/morhada"
                                        external
                                        fontSize={{ base: "sm", md: "md" }}
                                        textAlign="center"
                                    >
                                        Morhada
                                    </Link>
                                </Stack>
                            </Stack>
                        </GridItem>
                        <GridItem
                            colSpan={isGreaterThanMd ? 5 : 12}
                            w="100%"
                            mt={{ base: 6, md: 0 }}
                        >
                            <Stack
                                align="flex-start"
                                h="100%"
                                alignItems={{ base: "center", md: "start" }}
                            >
                                <Text fontWeight={700} fontSize="xl" color="#797979">
                                    Ligas
                                </Text>
                                <Link
                                    href="https://blog.grupoguia.mx"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Blog
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/valuacion"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Valuación
                                </Link>
                                <Link
                                    href="https://vip.grupoguia.mx/"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Login VIP
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/nosotros"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Corporativo
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/pld"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Manual de cumplimiento PLD
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/Aviso-de-privacidad"
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Aviso de privacidad
                                </Link>
                                <Link href={terms} external fontSize={{ base: "sm", md: "md" }}>
                                    Términos y condiciones
                                </Link>
                                <Link
                                    href="https://soporte.grupoguia.mx/"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Soporte técnico
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/cartaderechosconsumidor"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Carta de derechos del consumidor
                                </Link>
                                <Link
                                    href="https://grupoguia.mx/politicanodiscriminacion"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Política de no discriminación
                                </Link>
                                <Link
                                    href="/estandares-de-conducta"
                                    external
                                    fontSize={{ base: "sm", md: "md" }}
                                >
                                    Código de Ética
                                </Link>
                            </Stack>
                        </GridItem>
                        <GridItem
                            colSpan={isGreaterThanMd ? 2 : 12}
                            w="100%"
                            mt={{ base: 10, md: 0 }}
                        >
                            <Stack h="100%" gap={4}>
                                <Stack alignItems={{ base: "center", md: "start" }}>
                                    <Text fontWeight={700} fontSize="xl" color="#797979">
                                        Grupo Guia
                                    </Text>
                                    <Link href="https://grupoguia.mx/retail/" external>
                                        Usos Comerciales
                                    </Link>
                                    <Link href="https://grupoguia.mx/industrial/" external>
                                        Usos Industriales
                                    </Link>
                                    <Link href="https://grupoguia.mx/secondhomes" external>
                                        Second homes
                                    </Link>
                                    <Link href="/tech" external>
                                        Tech
                                    </Link>
                                </Stack>
                            </Stack>
                        </GridItem>
                    </Grid>
                </Stack>
            </Container>
            <Box>
                <Container
                    borderTopWidth={1}
                    borderStyle="solid"
                    borderColor="gray.200"
                    maxW="8xl"
                    mx="auto"
                    py={{ base: 10, md: 4 }}
                    direction={{ base: "column", md: "column" }}
                    spacing={4}
                    justify={{ md: "space-between" }}
                    align={{ md: "center" }}
                    asChild
                >
                    <Stack>
                        <Flex w="100%" direction={{ base: "column", md: "row" }} justify="center">
                            <Text
                                fontSize="14px"
                                fontWeight={500}
                                color="#737373"
                                textAlign="center"
                            >
                                Algunos derechos reservados GUIA EXCELENCIA INMOBILIARIA S.A. DE
                                C.V. 2025
                            </Text>
                        </Flex>
                    </Stack>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;
